import type * as React from 'react'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

/* ────────────────────────── Types ────────────────────────────────── */

interface InspectionDetailsSectionProps {
	/** Child DetailField components */
	children: React.ReactNode
	/** Layout direction - horizontal creates a flex row, vertical stacks */
	layout?: 'horizontal' | 'vertical'
	/** Optional className for the container */
	className?: string
	/** Whether to show separator after this section */
	showSeparator?: boolean
}

/* ────────────────────────── Component ───────────────────────────── */

/**
 * Wrapper component for grouping DetailField components in inspection details views.
 * Automatically handles layout, spacing, and separators to reduce boilerplate.
 */
export function InspectionDetailsSection({
	children,
	layout = 'horizontal',
	className,
	showSeparator = true,
}: InspectionDetailsSectionProps) {
	return (
		<>
			<div
				className={cn(
					layout === 'horizontal' ? 'flex flex-wrap gap-4' : 'space-y-4',
					className,
				)}
			>
				{children}
			</div>
			{showSeparator && <Separator />}
		</>
	)
}
